import { Box, Center, Flex, Heading, Spinner } from "@chakra-ui/react";
import BorrowerContacts from "components/borrowers/BorrowerContacts";
import LoanHeaderDetail from "components/elements/LoanHeaderDetail";

import UserAvatar from "components/elements/UserAvatar";
import PageHeader from "components/layout/PageHeader";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { apiRequest } from "utils/api";
import EditBorrower from "./EditBorrower";
import DeleteBorrowerBtn from "./DeleteBorrowerBtn";
import { isPermissionEnabled, permissionConstants, hasPermission } from "utils/permissionHelper";
import { useTenant } from "modules/tenant/providers/tenant-provider";
import EditBorrowerFields from "./EditBorrowerFields";
import FieldsTable from "pages/Borrower/FieldsTable/index";
import NoResults from "components/elements/NoResults";
import LoansTable from "components/elements/LoansTable";

function Borrower() {
  const { id } = useParams();
  const { user } = useTenant();

  const [borrower, setBorrower] = useState<any | null>(null);
  const [borrowerFields, setBorrowerFields] = useState<any | null>(null);
  const [loading, setLoading] = useState(true);

  async function loadBorrower() {
    setLoading(true);
    const { user: borrowerUser } = await apiRequest("/supabase/users/single", {
      id,
    });
    setBorrower(borrowerUser);
    const borrower_company_id = borrowerUser?.company?.id;
    const BorrowerFieldsToAsign = await apiRequest("/supabase/borrower_detail/select", {
      borrower_company_id,
      borrowerId: id,
    });
    setBorrowerFields(BorrowerFieldsToAsign.borrower_fields);
    setLoading(false);
  }

  useEffect(() => {
    if (id) {
      loadBorrower();
    }
  }, [id]);

  const checkPermission = () => {
    if (hasPermission(user, permissionConstants.editBorrower)) {
      //permission check
      return true;
    }
    if (!isPermissionEnabled(user)) {
      // no permissions
      return true;
    }
    return false;
  };

  return borrower ? (
    <>
      <PageHeader
        title="Borrower Profile"
        breadcrumbs={[
          {
            title: "Borrowers",
            to: "/borrowers",
          },
          {
            title: borrower.company.name,
            to: `/companies/${borrower.company.id}`,
          },
          {
            title: `${borrower.first_name} ${borrower.last_name}`,
          },
        ]}
      />
      <Box px="28px" py="20px" bg="white" mb="20px" borderRadius="20px">
        <Flex alignItems="center">
          <UserAvatar size="65px" mr="16px" user={borrower} />
          <Flex flexDir="column" flex="1">
            <Flex justifyContent="space-between" alignContent="center">
              <Heading fontSize="20px" fontWeight="600" mb="12px">
                {borrower.first_name} {borrower.last_name}
              </Heading>
              {checkPermission() && (
                <EditBorrower borrower={borrower} loadBorrower={loadBorrower} />
              )}
            </Flex>
            <Flex justifyContent="space-between">
              <LoanHeaderDetail label="Email" text={borrower.email} />
              <LoanHeaderDetail label="Company Name" text={borrower.company.name} />
              <LoanHeaderDetail
                label="Company Address"
                text={borrower.company.address?.formatted || "Not Provided"}
              />
              <LoanHeaderDetail
                label="Entity"
                text={borrower.entity?.name ?? "Not Provided"}
                link={
                  borrower.entity?.id
                    ? `/companies/${borrower.company.id}/entities/${borrower.entity?.id}`
                    : undefined
                }
              />
            </Flex>
          </Flex>
        </Flex>
      </Box>
      <Flex>
        <Box flex="3" mr="20px">
          <Box bg="white" borderRadius="20px" py="16px" px="26px" mt="0px" mb="14px">
            <Box display="flex" justifyContent={"space-between"} alignItems={"center"}>
              <Heading fontWeight="600" fontSize="20px" mb="6px">
                Borrower Details
              </Heading>
              <EditBorrowerFields
                borrower={borrower}
                loadBorrower={loadBorrower}
                fields={borrowerFields}
                setFields={setBorrowerFields}
              />
            </Box>
            <FieldsTable id={borrower.id} fields={borrowerFields} columns={2} />
            {borrowerFields && borrowerFields.length == 0 && (
              <Box
                display={"flex"}
                justifyContent={"center"}
                alignItems={"center"}
                mt={"30px"}
                h={"150px"}
              >
                <NoResults loading={loading} message="No fields added yet..." />
              </Box>
            )}
          </Box>
          <Box bg="white" borderRadius="20px" py="16px" px="26px" mt="0px" mb="14px">
            <Heading fontWeight="600" fontSize="20px" mb="6px">
              Loans
            </Heading>
            <LoansTable
              small
              borrower_id={borrower.id}
              columns={["Date", "Name", "Type", "Status", "Amount"]}
            />
          </Box>
        </Box>
        <Box flex="2">
          {/* <VerificationStatus borrower={borrower} /> */}
          <BorrowerContacts borrower={borrower} loadBorrower={loadBorrower} />
          <DeleteBorrowerBtn id={borrower.id} />
        </Box>
      </Flex>
    </>
  ) : (
    <Center>
      <Spinner />
    </Center>
  );
}

export default Borrower;
